import { selectors } from 'publisher/reducers/webinarSession'
import { shallowEqual, useSelector } from 'react-redux'

export { selectors }

export default function useWebinarSession(selector) {
  return useSelector(state => selector(state.webinar), shallowEqual)
}
